<ion-app>
  <div class="safe-area-header"></div>
  <ion-router-outlet/>
  <div class="safe-area-footer"></div>
</ion-app>
